// Pages
import PageDefault, { PageDefaultModel } from './components/model/pages/PageDefault';
// import PageTest, { PageTestModel } from './components/model/pages/PageTest';

import HomePage, { HomePageModel } from '../App/pages/view/HomePage';
import ProductViewPage, { ProductViewPageModel } from '../Product/pages/view/ProductViewPage';
import SubscriptionViewPage, { SubscriptionViewPageModel } from '../Subscription/pages/view/SubscriptionViewPage';
import ReviewListPage, { ReviewListPageModel } from '../Review/pages/view/ReviewListPage';
import ReviewAddPage, { ReviewAddPageModel } from '../Review/pages/view/ReviewAddPage';
import ContactPage, { ContactPageModel } from '../Contact/pages/view/ContactPage';
import PageMenu, { PageMenuModel } from './components/model/pages/PageMenu';

// Blocks
import PanelDefault, { PanelDefaultModel } from './components/model/panels/PanelDefault';
import PanelFooterLinks, { PanelFooterLinksModel } from '../App/components/view/PanelFooterLinks';
import PanelMainMenu, { PanelMainMenuModel } from '../App/components/menu/PanelMainMenu';
import PanelCallToActionMenu, { PanelCallToActionMenuModel } from '../App/components/menu/PanelCallToActionMenu';
import PanelProductBenefits, { PanelProductBenefitsModel } from '../Product/components/view/PanelProductBenefits';
import PanelProductHighlight, { PanelProductHighlightModel } from '../Product/components/view/PanelProductHighlight';


export const CMS_PAGE_MODEL_DEFAULT = PageDefaultModel;
export const CMS_PAGE_MODELS = [PageDefaultModel, HomePageModel, ProductViewPageModel, SubscriptionViewPageModel, ReviewListPageModel, ReviewAddPageModel, ContactPageModel, PageMenuModel];
export const CMS_PANEL_MODELS = [PanelDefaultModel, PanelProductBenefitsModel, PanelProductHighlightModel, PanelMainMenuModel, PanelCallToActionMenuModel, PanelFooterLinksModel];
export const CMS_PANEL_MODEL_DEFAULT = PanelDefault;


export function getModels(type = null) {
    return [...CMS_PAGE_MODELS, ...CMS_PANEL_MODELS].filter(model => type === null || (model && type === model.type));
}

export function getModel(type, name) {
    return getModels(type).find(model => model.name === name);
}

export function getPageModelViewer(model) {
    switch(model) {
        // Add custom model page
        // case 'xyz':
        //     return <PageXyz page={this.props.page} />;
        case 'home':
            return HomePage;

        case 'product':
            return ProductViewPage;

        case 'subscription':
            return SubscriptionViewPage;

        case 'reviews':
            return ReviewListPage;

        case 'reviewAdd':
            return ReviewAddPage;

        case 'contact':
            return ContactPage;

        case 'pageMenu':
            return PageMenu;

        // case 'test':
        //     return PageTest;

        case 'default':
        default:
            return PageDefault;
    }
}

export function getPanelModelViewer(model) {
    switch(model) {
        // Add custom model page
        // case 'xyz':
        //     return <PageXyz page={this.props.page} />;
        case 'mainMenu':
            return PanelMainMenu;

        case 'ctaMenu':
            return PanelCallToActionMenu;

        case 'footerLinks':
            return PanelFooterLinks;

        case 'productBenefits':
            return PanelProductBenefits;

        case 'productHighlight':
            return PanelProductHighlight;

        // case 'catchPhrase':
        //     return PanelHomeCatchPhrase;

        case 'default':
        default:
            return PanelDefault;
    }
}
